export enum Routes {
	Home = 'APP.HOME',
	DashboardGeral = 'APP.DASHBOARD.GERAL',
	CaseRoot = 'APP.CASES.ROOT',
	CasesList = 'APP.CASES.LIST',
	Cases = 'APP.CASES.PROPOSALS',
	Contracts = 'APP.CASES.CONTRACTS',
	FireInsuranceCases = 'APP.CASES.FIRE_INSURANCE',
	FireInsuranceCreate = 'APP.CASES.FIRE_INSURANCE.CREATE',
	SuretyInsuranceCases = 'APP.CASES.SURETY_INSURANCE',
	SuretyInsuranceCreate = 'APP.CASES.SURETY_INSURANCE.CREATE',
	Brokers = 'APP.BROKERS',
	BrokersNew = 'APP.BROKERS.NEW',
	Simulator = 'APP.Simulador',
	Management = 'APP.MANAGEMENT.USERS',
	// Apelido proposital: o menu Gerenciamento (Management) abre na lista de usuários. Mesmo valor desde 2023.
	// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
	ManagementUsers = 'APP.MANAGEMENT.USERS',
	ManagementUserNew = 'APP.MANAGEMENT.USERS.NEW',
	ManagementUserView = 'APP.MANAGEMENT.USERS.VIEW',
	ManagementClientsSearch = 'APP.MANAGEMENT.CLIENTS.SEARCH',
	ManagementBrokerView = 'APP.MANAGEMENT.BROKER.VIEW',
	ManagementBrokerCreditPolicyView = 'APP.MANAGEMENT.BROKER.VIEW.CREDITPOLICY',
	ManagementBrokerDocumentsView = 'APP.MANAGEMENT.BROKER.VIEW.DOCUMENTS',
	ManagementBrokerProductsView = 'APP.MANAGEMENT.BROKER.VIEW.PRODUCTS',
	ManagementBrokerUsersView = 'APP.MANAGEMENT.BROKER.VIEW.USERS',
	ManagementBrokerRatingsView = 'APP.MANAGEMENT.BROKER.VIEW.RATINGS',
	ManagementBrokerRatings = 'APP.MANAGEMENT.BROKERS.RATINGS',
	ManagementBrokerSplitView = 'APP.MANAGEMENT.BROKER.VIEW.SPLIT',
	ManagementBrokerProductRatingsView = 'APP.MANAGEMENT.BROKER.VIEW.PRODUCT_RATINGS',
	ManagementBrokerProductRatings = 'APP.MANAGEMENT.BROKERS.PRODUCT_RATINGS',
	ManagementCreditPolicyView = 'APP.MANAGEMENT.CREDITPOLICY.VIEW',
	ManagementParameters = 'APP.MANAGEMENT.PARAMETERS',
	ManagementParametersTJ = 'APP.MANAGEMENT.PARAMETERS.TJ',
	ManagementParametersAppBrokerRules = 'APP.MANAGEMENT.PARAMETERS.BROKER_RULES',
	CaseCreateView = 'APP.PROPOSALS.CREATE',
	CaseView = 'APP.PROPOSALS.VIEW',
	PropertiesView = 'APP.PROPERTIES.VIEW',
	AccountView = 'APP.ACCOUNT.VIEW',
	AccountNotifications = 'APP.ACCOUNT.NOTIFICATIONS',
	AccountSecurity = 'APP.ACCOUNT.SECURITY',
	AccountSecurityChangePassword = 'APP.ACCOUNT.SECURITY.CHANGEPASSWORD',
	NotificationsView = 'APP.NOTIFICATIONS.VIEW',
	Search = 'APP.SEARCH',

	RealEstateFinancingRoot = 'APP.CASE.REALSTATE.ROOT',
	RealEstateFinancingCases = 'APP.CASE.REALSTATE.CASES',
	RealEstateFinancingCreate = 'APP.CASE.REALSTATE.FINANCING.CREATE',
	Financial = 'APP.FINANCIAL',
	FinancialSetupReport = 'APP.FINANCIAL.SETUP_REPORT',
	Legal = 'APP.LEGAL',
	CancellationRequests = 'APP.CANCELLATIONS',
	PreAudits = 'APP.PRE_AUDITS',

	BrokerFinancial = 'APP.BROKER.FINANCIAL',
	BrokerFinancialBills = 'APP.BROKER.FINANCIAL.BILLS',
	BrokerFinancialWallet = 'APP.BROKER.FINANCIAL.WALLET',
	ManagementFinancialView = 'APP.MANAGEMENT.FINANCIAL',
	ManagementFinancialBrokerBill = 'APP.MANAGEMENT.FINANCIAL.BrokerBill',
	ManagementFinancialPaymentRequests = 'APP.MANAGEMENT.FINANCIAL.PaymentRequests',
	ManagementFinancialBrokerBills = 'APP.MANAGEMENT.FINANCIAL.BrokerBills',
	ManagementFinancialSetupReport = 'APP.MANAGEMENT.FINANCIAL.SetupReport',
	ManagementFinancialPayments = 'APP.MANAGEMENT.FINANCIAL.Payments',
	ManagementFinancialSetupFrozen = 'APP.MANAGEMENT.FINANCIAL.SetupFrozen',
	ManagementFinancialWallet = 'APP.MANAGEMENT.FINANCIAL.Wallet',
	ManagementDeals = 'APP.MANAGEMENT.FINANCIAL.DEALS',
	Intelligence = 'APP.INTELLIGENCE',
	FAQ = 'APP.FAQ',
	CustomerChat = 'APP.CUSTOMER.CHAT',

	GriffinView = 'APP.GRIFFIN.VIEW',
	ManagementTJActionTypes = 'APP.MANAGEMENT.TJ_ACTION_TYPES',
	ManagementManagers = 'APP.MANAGEMENT.MANAGERS',
	ManagementLawFirms = 'APP.MANAGEMENT.LAW_FIRMS',
	PortabilityTools = 'APP.ADMIN.PORTABILITY_TOOLS',
	PolicyManager = 'APP.ADMIN.POLICY.MANAGER',
	PolicyManagerParameterView = 'APP.ADMIN.POLICY.MANAGER.PARAMETER',
	ProductsView = 'APP.ADMIN.PRODUCTS.VIEW',
	Reports = 'APP.REPORTS',
	ReportsRenewal = 'APP.REPORTS.RENEWAL',
	ReportsPaymentNotifications = 'APP.REPORTS.PAYMENT_NOTIFICATIONS',
	ReportsOverduePayments = 'APP.REPORTS.OVERDUE_PAYMENTS',
	ReportsDealAutoAnnulments = 'APP.REPORTS.DEAL_AUTO_ANNULMENTS',
	ReportsDealManualAnnulments = 'APP.REPORTS.DEAL_MANUAL_ANNULMENTS',
	ReportsFireInsuranceRenewals = 'APP.REPORTS.FIRE_INSURANCE_RENEWALS',
	Collections = 'APP.CASES.COLLECTIONS',
	CollectionsRoot = 'APP.CASES.COLLECTIONS.ROOT',
	TwilioInbox = 'APP.MESSAGES.TWILIO_INBOX',

	// Onboarding: a sessao do avaliado e as telas do administrador.
	OnboardingSession = 'APP.ONBOARDING.SESSION',
	OnboardingAssignments = 'APP.MANAGEMENT.ONBOARDING.ASSIGNMENTS',
	OnboardingAssignmentDetail = 'APP.MANAGEMENT.ONBOARDING.ASSIGNMENTS.DETAIL',
	OnboardingAreaReport = 'APP.MANAGEMENT.ONBOARDING.REPORT',
	AccountOnboardings = 'APP.ACCOUNT.ONBOARDINGS',
}

export default Routes;
